import dytPage from './dyt-page.vue';

export default dytPage;
